module.exports = __webpack_public_path__ + "static/img/img_shengjizongheti.c1c1ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/img_shengjizongheti.png
// module id = 44yI
// module chunks = 1